
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateOrdercartFromCalculationitemsDtoFormGroup() {
return new FormGroup({
    calculationitemIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      